import VuiButton from './button.vue'
import VuiIco from './ico.vue'
import VuiSpin from './ui/Spin.vue'
import VuiScroll from './ui/Scroll.vue'
import VuiContextMenu from './ui/ContextMenu.vue'

const components = {
  VuiButton,
  VuiIco,
  VuiSpin,
  VuiScroll,
  VuiContextMenu,
}

export default {
  install (Vue) {
    Object.keys(components).forEach((key) => {
      Vue.component(key, components[key])
    })
  },
}
